export const PRE_SELECTED_FILTERS = 'preSelectedFilters';
export const PRE_SELECTED_ADVANCED_FILTERS = 'preSelectedAdvancedFilters';
